import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { ExtensionDefinition } from '@backstage/frontend-plugin-api';

export const entityNucleusContent: ExtensionDefinition<any> = EntityContentBlueprint.make({
  name: 'nucleus',
  params: {
    path: '/nucleus',
    title: 'Nucleus',
    filter: 'kind:component',
    loader: async () => {
      const { EntityNucleusContent } = await import('../components/EntityNucleusContent');
      return <EntityNucleusContent />;
    },
  },
});
